import { SearchQuery, initSearchPagination } from './searchPagination';

declare global {
  interface Window {
    query?: SearchQuery;
    currentPage?: number;
    numberOfPages?: number;
  }
}

/**
 * Handles select change redirection safely
 */
export function onSelectChange(select: HTMLSelectElement): void {
  const dataLocation = select.dataset.location ?? '';
  const selectedValue = select.value ?? '';
  window.location.href = '/' + encodeURIComponent(dataLocation).replace(/%2F/g, '/') + selectedValue;
}

/**
 * Initializes search filters from #ModelSearchQuery dataset
 */
export function initSearchBlogEbookAuthor(): void {
  const queryTypeValue = document.getElementById('ModelSearchQuery') as HTMLElement | null;

  if (queryTypeValue) {
    const totalResults = parseInt(queryTypeValue.dataset.totalresults ?? '0', 10);
    const pagination = parseInt(queryTypeValue.dataset.pagination ?? '20', 10);

    const numberOfPages = pagination > 0 ? Math.ceil(totalResults / pagination) : 1;
    const currentPage = parseInt(queryTypeValue.dataset.currentpage ?? '1', 10);
    const query: SearchQuery = {
      type: queryTypeValue.dataset.querytype ?? '',
      value: queryTypeValue.dataset.queryvalue ?? '',
    };

    // Assign to window for backwards compatibility with any existing Sitecore scripts
    window.numberOfPages = numberOfPages;
    window.currentPage = currentPage;
    window.query = query;

    const tags = document.getElementById('tags') as HTMLSelectElement | null;
    const categories = document.getElementById('categories') as HTMLSelectElement | null;

    if (tags) {
      tags.value = query.type === 'tag' ? `/tags/${query.value}` : '';

      if (query.type === 'category' && categories) {
        categories.value = `/category/${query.value}`;
        if (query.value === 'all') {
          categories.selectedIndex = 0;
        }
      }

      tags.addEventListener('change', () => onSelectChange(tags));
      categories?.addEventListener('change', () => onSelectChange(categories));
    }

    // Direct render without race condition if #pages exists
    initSearchPagination({
      currentPage,
      numberOfPages,
      query,
    });
  }
}
